export const headerConfig = {
  reportDt: {
    id: 1,
    title: "Date of creation",
    value: "creationDate",
    order: 1,
  },
};
